import { render } from "./LeaseOverview.vue?vue&type=template&id=b8f352d4&scoped=true"
import script from "./LeaseOverview.vue?vue&type=script&lang=js"
export * from "./LeaseOverview.vue?vue&type=script&lang=js"

import "./LeaseOverview.vue?vue&type=style&index=0&id=b8f352d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f352d4"]])

export default __exports__